import React from 'react'
import styled from '@emotion/styled'
import { Global, css } from '@emotion/core'
import Header from './Header'
import Footer from './Footer'

const StyledLayout = styled.div`
  position: relative;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;

  main {
    padding: 0 20px;
  }
`

const Layout = ({ children }) => (
  <StyledLayout>
    <Global
      styles={css`
        body {
          position: relative;
        }
      `}
    />
    <Header />
    <main>{children}</main>
    <Footer />
  </StyledLayout>
)

export default Layout
